import { debounce } from "lodash-es";

export default class Header {
    constructor(selector) {
        this.header = document.querySelector(selector);

        /* Add class on scroll */
        this.handleScroll();
    }

    handleScroll() {
        window.addEventListener(
            "scroll",
            debounce(
                e => {
                    if (window.scrollY > 0) {
                        this.header.classList.add("-scrolled");
                    } else {
                        this.header.classList.remove("-scrolled");
                    }
                },
                16,
                { leading: true, trailing: true }
            )
        );
    }
}
